export class QueryBuilderUpdate{
  ids: Array<number> = [];
  fieldName: string;
  newValue: string;
}
